
<div class="card sq-card">
    <div class="card-header card-header-squirrel">
        <h4>{{this.translate.data['GROUPROLEUSERS'] | translate}}</h4>
        {{groupRoleName}}
    </div>
    <div class="card-body">
        <!-- <a (click)="cancel()" style="float: right; cursor: pointer; margin-top: -40px; margin-right: 10px;">
            <mat-icon aria-hidden="false" aria-label="icon">icon_delete</mat-icon>
        </a> -->

        <div class="group-role-user-tables" style="max-height:40px;" >
            <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                    Squirrel's API rate limit has been reached. It will be reset in one minute.
                </div>
            </div>
            <!-- <div class="row" style="max-width: 650px;">
                <a>
                    <input type="text" placeholder="{{this.translate.data['SEARCH'] | translate}}"
                    (input)="onFilterTextBoxChanged($event)" style="padding:4px; width:500px;margin-left: 20px;"/>
                </a>                   
                <span style="flex: 1 1 auto"></span>
                <a>
                    <mat-icon style="margin-top: 6px; margin-right: 31px" (click)="cancel()" matTooltip="Nur Nicht-Mitglieder anzeigen" aria-hidden="false" aria-label="icon">check_box_outline_blank</mat-icon>
                </a>
            </div> -->
            <div class="row" style="max-width:695px; display:flex; align-items:center; justify-content:space-between;">
                <input type="text"
                    placeholder="{{this.translate.data['SEARCH'] | translate}}"
                    (input)="onFilterTextBoxChanged($event.target.value)"
                    (keyup.enter)="onFilterTextBoxChanged($event.target.value)"
                    (keyup.backspace)="onFilterTextBoxChanged($event.target.value)"
                    style="padding:4px; width:500px; margin-left:20px;" />

                    <!-- keyup.enter
                    keyup.tab
                    keyup.esc   //alias für escape
                    keyup.space
                    keyup.backspace
                    keyup.delete
                    keyup.insert
                    keyup.home
                    keyup.end
                    keyup.pageup
                    keyup.pagedown
                    keyup.up     // ArrowUp 
                    keyup.down   // ArrowDown 
                    keyup.left   // ArrowLeft 
                    keyup.right  // ArrowRight
                    -->
                <div style="position:relative; display:inline-flex; align-items:center;"
                    (click)='search("ALL_USERS")' matTooltip="Alle Benutzer anzeigen" aria-hidden="false" aria-label="indeterminate_check_box" >
                        <mat-icon-button
                            [ngClass]="{'buttonSelected': isAllUsersLoaded }"
                            style="width:40px; height:40px; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; padding:0;">
                            <i class="material-icons">indeterminate_check_box</i>
                        </mat-icon-button>
                </div>
                <div style="position:relative; display:inline-flex; align-items:center;"
                    (click)='search("ONLY_MEMBERS")' matTooltip="Nur Mitglieder anzeigen" aria-hidden="false" aria-label="check_box" >
                        <mat-icon-button
                            [ngClass]="{'buttonSelected': isMemberOnlyLoaded }"
                            style="width:40px; height:40px; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; padding:0;">
                            <i class="material-icons">check_box</i>
                        </mat-icon-button>
                </div>
                <div style="position:relative; display:inline-flex; align-items:center;"
                    (click)='search("NON_MEMBERS")' matTooltip="Nur Nicht-Mitglieder anzeigen" aria-hidden="false" aria-label="check_box_outline_blank" >
                        <mat-icon-button
                            [ngClass]="{'buttonSelected': isNonMemberOnlyLoaded }"
                            style="width:40px; height:40px; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; padding:0;">
                            <i class="material-icons">check_box_outline_blank</i>
                        </mat-icon-button>
                </div>
                    <!-- Punkt anzeigen, wenn highlightMode === 'dot' -->
                    <!-- <span 
                          style="position:absolute; top:4px; right:4px; width:8px; height:8px; background:#ff4081; border-radius:50%;">
                    </span> -->

                    <!-- Strich anzeigen -->
                    <!-- <span *ngIf="isAllUsersLoaded"
                          style="position:absolute; left:6px; right:6px; bottom:26px; height:2px; background:currentColor;">
                    </span> -->

            </div>
        </div>

        <div class="group-role-user-tables" style="max-height:300px; overflow-y:auto;" >
            <ag-grid-angular  style="width:700px; height:100%; padding: 5px; overflow-y:auto;" 
            class="ag-theme-balham"
            [overlayLoadingTemplate]="overlayLoadingTemplate"
            [domLayout]="'autoHeight'"
            [gridOptions]="gridOptions" 
            (gridReady)="onGridReady($event)" 
            [frameworkComponents]="frameworkComponents">
            </ag-grid-angular>
        </div>
        <mat-accordion style="width:700px; margin: 12px 20px;">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Weitere Mitglieder hinzufügen
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div style="border:1px solid rgba(0,0,0,0.12); border-radius:4px; padding:8px; background:#fff;">
                    <textarea
                        [(ngModel)]="emails"
                        rows="5"
                        placeholder="E-Mail-Adressen (getrennt durch Kommata, Leerzeichen oder Zeilenumbrüche) eingeben"
                        style="width:100%; resize:vertical; border: none; outline: none; font-size:14px; padding:6px;"
                    ></textarea>
                </div>
                <div class="row">
                    <a>
                        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 15px;" matTooltip="E-Mail-Adresse(n) hinzufügen"
                                        (click)="addUserToGroupRole()" >Hinzufügen</button>
                    </a>                   
                    <a> <mat-icon
                    matTooltip="Durch Komma, Leerzeichen oder Zeilenumbrüche getrennte E-Mail-Adressen eingeben, um schnell mehrere Benutzer zur Projektrolle hinzuzufügen. 
                        Sollten die Benutzer noch nicht im Mandanten vorhanden sein, so werden sie eingeladen und bekommen die Projektrolle zugewiesen."
                    matTooltipPosition="right"
                    style="cursor: pointer; color: #303f6f;margin-top: 14px; margin-left: 5px;">
                    info
                    </mat-icon>
                    </a>
                </div>
            </mat-expansion-panel>
        </mat-accordion>



        <div class="row" style="margin-top: 20px">
            <!-- <button matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}" mat-button  (click)="cancel()">
                <mat-icon>close</mat-icon>
            </button> -->
                <!-- <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-right: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="cancel()" >ABBRECHEN</button>
                </a>                    -->
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 20px;" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="cancel()" >ABBRECHEN</button>
                </a>                   
            <span style="flex: 1 1 auto"></span>
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-right: 31px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="saveData()" >Übernehmen</button>
                </a>                   
                    <!-- <button matTooltip="{{this.translate.data['TOOLTIPADDUSER'] | translate}}" mat-button (click)="openUserGroupRoleDialog()">
                <mat-icon>person_add</mat-icon>
            </button> -->
            
            <!-- <span style="flex: 1 1 auto"></span> -->
        </div>      
    </div>
</div>
